/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolEcoIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-eco"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M11.3 22.6Q10.4 22.6 9.53 22.44Q8.65 22.27 7.83 21.93Q7.97 18.73 9.5 15.93Q11.03 13.13 13.4 10.95Q10.53 12.45 8.46 14.91Q6.4 17.38 5.47 20.5Q5.35 20.38 5.21 20.26Q5.08 20.15 4.95 20.02Q3.67 18.75 3.01 17.19Q2.35 15.63 2.35 13.95Q2.35 12.13 3.09 10.49Q3.83 8.85 5.1 7.55Q6.9 5.75 9.49 5.01Q12.07 4.28 16.5 4.4Q17.35 4.42 18.07 4.76Q18.8 5.1 19.38 5.67Q19.95 6.25 20.27 6.97Q20.6 7.7 20.65 8.55Q20.77 12.95 20.05 15.54Q19.32 18.13 17.52 19.93Q16.23 21.23 14.63 21.91Q13.03 22.6 11.3 22.6Z" fill={color} />
    </svg>
  );
}
